import { render, staticRenderFns } from "./MedicalServices.vue?vue&type=template&id=be03a0cc&scoped=true&"
import script from "./MedicalServices.vue?vue&type=script&lang=js&"
export * from "./MedicalServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be03a0cc",
  null
  
)

export default component.exports